// extracted by mini-css-extract-plugin
export default {"loaderFullScreen":"Loader_loaderFullScreen__g3IU0","loader-big":"Loader_loader-big__8jgcS","loader":"Loader_loader__vSBSw"};